<div
  class="page-container"
  [ngStyle]="{
    '--color50': seminarCategory?.color50 ?? booking.seminar.category.color50,
    '--color0': seminarCategory?.color0 ?? booking.seminar.category.color0,
    '--color70': seminarCategory?.color70 ?? booking.seminar.category.color70,
    '--color80': seminarCategory?.color80 ?? booking.seminar.category.color80,
    '--color90': seminarCategory?.color90 ?? booking.seminar.category.color90,
  }">
  @if (bookingSummary) {
    <div class="page-title justify-space-between summary-title">
      <div class="flex-c gap-10">
        <div class="font-bold-display-medium title">
          Zusammenfassung Kursanmeldung
        </div>
        <div class="font-regular-title-large flex-r gap-4 font-color-black">
          <span class="seminar-title">
            {{ booking.seminar.title }}
          </span>
        </div>
      </div>
    </div>
  } @else {
    <div class="page-title justify-space-between padding-36-0">
      <div class="flex-c gap-10 flex-2-1-0">
        <div class="font-bold-display-medium title">Buchungsübersicht</div>
        <div class="font-regular-title-large flex-r gap-4 font-color-black">
          <span class="underlined seminar-title">
            {{ booking.seminar.title }}
          </span>
          @if (booking.status !== 'waitlist') {
            <span>/</span>
            <span class="underlined">
              Rechnungsnummer:
              <span class="no-wrap">
                {{ booking.invoice?.invoiceNr }}
              </span>
            </span>
          }
        </div>
      </div>
      <div class="flex-c align-end gap-10 flex-1-1-0">
        <span class="font-regular-title-large text-align-end font-color-black">
          Buchungsnummer: <span class="no-wrap">{{ booking.bookingNr }}</span>
        </span>
        <div [class]="getStatus(booking).class">
          {{ getStatus(booking).status }}
        </div>
      </div>
    </div>
  }
  <div class="main-content">
    <div class="container">
      <div class="title flex-r align-center gap-8">
        <i class="fa-regular fa-book-bookmark fa-2x"></i>
        <span class="font-medium-title-large">Ausgewähltes Seminar</span>
      </div>
      <div class="flex-r align-center gap-4 align-self-stretch">
        <div class="inwi-radio">
          <input type="radio" name="courseChoice" checked />
        </div>
        <div class="flex-c align-start gap-4 flex-1-0-0">
          <span class="font-medium-title-medium">
            {{ booking.seminarDateSeries.name }}
          </span>
          @for (date of booking.seminarDateSeries.dates; track date.id) {
            <span class="font-regular-body-large">
              Teil {{ $index + 1 }}:
              {{ date.startDate | date: 'dd. MMMM HH:mm' }} -
              {{ date.endDate | date: 'HH:mm' }}
            </span>
          }
        </div>
      </div>
    </div>
    @if (isAdminView && hasOpenQuestions()) {
      <div class="container">
        <div class="title flex-r align-center gap-8">
          <i class="fa-regular fa-book-bookmark fa-2x"></i>
          <span class="font-medium-title-large">Offene Fragen</span>
        </div>

        <ul class="questions-list">
          @for (participant of booking.participants; track participant.id) {
            <li class="font-regular-body-large">
              {{ participant.questions }}
            </li>
          }
        </ul>
      </div>
    }
    @for (participant of booking.participants; track $index) {
      <div class="container">
        <div
          class="flex-r justify-space-between gap-10 align-center align-self-stretch flex-1-1-0 cursor-pointer"
          (click)="toggleCollapse($index)">
          <div class="title flex-r align-center gap-8">
            <i class="fa-regular fa-user fa-2x"></i>
            <span class="font-medium-title-large">
              {{ participant.firstName }} {{ participant.lastName }}
            </span>
          </div>
          <button class="circle-small border-none font-color-black">
            <i
              class="fa-regular circle-icon"
              [class]="
                !isExpanded($index) ? 'fa-chevron-up' : 'fa-chevron-down'
              "></i>
          </button>
        </div>
        @if (!isExpanded($index)) {
          <div class="flex-c gap-28 font-color-black">
            <div class="flex-r gap-24 flex-wrap">
              @if (participant.salutation) {
                <div class="flex-c gap-8">
                  <div class="font-medium-title-medium">Anrede</div>
                  <div class="font-regular-body-large">
                    {{ participant.salutation }}
                  </div>
                </div>
              }
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Vorname</div>
                <div class="font-regular-body-large">
                  {{ participant.firstName }}
                </div>
              </div>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Nachname</div>
                <div class="font-regular-body-large">
                  {{ participant.lastName }}
                </div>
              </div>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Geburtsdatum</div>
                <div class="font-regular-body-large">
                  {{ participant.birthdate | date: 'dd.MM.yyyy' }}
                </div>
              </div>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Beruf</div>
                <div class="font-regular-body-large">
                  {{ participant.jobTitle ?? '--' }}
                </div>
              </div>
            </div>
            @if (participant.street || participant.city) {
              <p-divider
                class="form-divider"
                [ngStyle]="{
                  '--general-70': booking.seminar.category.color70,
                }"></p-divider>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Adresse</div>
                <div class="font-regular-body-large">
                  {{ participant.street }} {{ participant.streetNr }}
                  <br />
                  {{ participant.zip }} {{ participant.city }},
                  {{ participant.country }}
                </div>
              </div>
            }
            <p-divider
              class="form-divider"
              [ngStyle]="{
                '--general-70': booking.seminar.category.color70,
              }"></p-divider>
            <div class="flex-r gap-24 flex-wrap">
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">E-Mail</div>
                <div class="font-regular-body-large">
                  {{ participant.email }}
                </div>
              </div>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Telefon</div>
                <div class="font-regular-body-large">
                  {{ participant.phoneNumber ?? '--' }}
                </div>
              </div>
            </div>
            @if (participant.questions) {
              <p-divider
                class="form-divider"
                [ngStyle]="{
                  '--general-70': booking.seminar.category.color70,
                }"></p-divider>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">
                  Fragen vorab/besonderes Interesse
                </div>
                <div class="font-regular-body-large pre-line">
                  {{ participant.questions }}
                </div>
              </div>
            }
            <p-divider
              class="form-divider"
              [ngStyle]="{
                '--general-70': booking.seminar.category.color70,
              }"></p-divider>
            <div class="font-medium-title-medium flex-r justify-end">
              {{ getCondition(participant.condition).text }}
              {{ participant.conditionPrice | currency: 'EUR' }}
            </div>
          </div>
        }
      </div>
    }
    <div class="container gap-16">
      <div
        class="flex-r align-center justify-space-between align-self-stretch gap-8">
        <div class="title flex-r align-center gap-8">
          <i class="fa-regular fa-euro-sign fa-2x"></i>
          <span class="font-medium-title-large"> Gesamtbetrag </span>
        </div>
        <div class="font-bold-title-large">
          {{ booking.totalPrice | currency: 'EUR' }}
        </div>
      </div>
      @if (booking.coupons?.length > 0) {
        <p-divider
          class="form-divider"
          [ngStyle]="{
            '--general-70': booking.seminar.category.color70,
          }"></p-divider>
        @for (couponCode of booking.coupons; track $index) {
          <div
            class="flex-r justify-space-between align-self-stretch align-center">
            <div class="inwi-chip-text-green-outline">
              Coupon: {{ couponCode.code }}
            </div>
            <div class="font-regular-title-medium">
              @if (couponCode.discountType === 'percentage') {
                -{{
                  booking.totalPrice * (couponCode.value / 100)
                    | currency: 'EUR'
                }}
              } @else {
                -{{ couponCode.value | currency: 'EUR' }}
              }
            </div>
          </div>
        }
        @if (booking.discountedPrice < 0) {
          <div class="inwi-text-error">
            Nach erfolgreicher Anmeldung wird dir ein Gutschein im Wert von
            {{ booking.discountedPrice * -1 | currency: 'EUR' }}
            ausgestellt.
          </div>
        }
        <div class="font-bold-title-large flex-r justify-end">
          Total:
          {{ getTotalPrice() | currency: 'EUR' }}
        </div>
      }
    </div>
    @if (booking.invoice) {
      <div class="container gap-16 font-color-black">
        <div
          class="flex-r justify-space-between gap-10 align-center align-self-stretch flex-1-1-0 cursor-pointer"
          (click)="billingAddressCollapsed = !billingAddressCollapsed">
          <div class="title flex-r align-center gap-8">
            <i class="fa-regular fa-receipt fa-2x"></i>
            <span class="font-medium-title-large">Rechnungsanschrift</span>
          </div>
          <button class="circle-small border-none font-color-black">
            <i
              class="fa-regular fa-xl circle-icon"
              [class]="
                billingAddressCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'
              "></i>
          </button>
        </div>
        @if (!billingAddressCollapsed) {
          <span>
            Diese Informationen sind wichtig, um die Rechnung zu erstellen und
            dich im Falle von Rückfragen bezüglich der Kursanmeldung zu
            kontaktieren.
          </span>
          @if (booking.invoice?.facility) {
            <div class="flex-c gap-8">
              <div class="font-medium-title-medium">Einrichtung</div>
              <div class="font-regular-body-large pre-line">
                {{ booking.invoice.facility }}
              </div>
            </div>
            <p-divider
              class="form-divider"
              [ngStyle]="{
                '--general-70': booking.seminar.category.color70,
              }"></p-divider>
          }
          <div class="flex-r gap-24">
            <div class="flex-c gap-8">
              <div class="font-medium-title-medium">Vorname</div>
              <div class="font-regular-body-large">
                {{ booking.invoice?.firstName }}
              </div>
            </div>
            <div class="flex-c gap-8">
              <div class="font-medium-title-medium">Nachname</div>
              <div class="font-regular-body-large">
                {{ booking.invoice?.lastName }}
              </div>
            </div>
          </div>
          <p-divider
            class="form-divider"
            [ngStyle]="{
              '--general-70': booking.seminar.category.color70,
            }"></p-divider>
          <div class="flex-c gap-8">
            <div class="font-medium-title-medium">Adresse</div>
            <div class="font-regular-body-large">
              {{ booking.invoice?.street }}
              {{ booking.invoice?.streetNr }}
              <br />
              {{ booking.invoice?.zip }}
              {{ booking.invoice?.city ? booking.invoice.city + ',' : '' }}
              {{ booking.invoice?.country }}
            </div>
          </div>
          <p-divider
            class="form-divider"
            [ngStyle]="{
              '--general-70': booking.seminar.category.color70,
            }"></p-divider>
          <div class="flex-r gap-24 flex-wrap">
            <div class="flex-c gap-8">
              <div class="font-medium-title-medium">E-Mail</div>
              <div class="font-regular-body-large">
                {{ booking.invoice?.email }}
              </div>
            </div>
            <div class="flex-c gap-8">
              <div class="font-medium-title-medium">Telefon</div>
              <div class="font-regular-body-large">
                {{ booking.invoice?.phoneNumber ?? '--' }}
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
